import axios from '../base/axios';
import API_KEY from './key';

const GET_UPCOMING = 'flixfrenzy/redux/GET_UPCOMING';

// eslint-disable-next-line default-param-last
const upComingReducer = (state = [], action) => {
  switch (action.type) {
    case GET_UPCOMING:
      return action.payload;
    default:
      return state;
  }
};

export const getUpComing = () => (dispatch) => {
  axios.get(`movie/upcoming?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_UPCOMING,
      payload: res.data,
    });
  });
};

export default upComingReducer;
